import { gtag_report_conversion_nitrogen_source } from './conversion-tags';

var query_string;
//get query parameter "q" value
//alert(getParameterByName('q'));

//get selected option value at start t
//alert(nitrogenSourceSelectedValue);
var nitrogenSourceSelectedValue;


$(document).ready(function(){
	$('.value-of-yield').hide(); //hide the icon near the calculations until there is a source selected
	//on change of quick-nitrogen-source option, change related labels and textboxes based on option value with "-nitrogen-source" as postfix
	$("#quick-nitrogen-source").change(function(){
		nitrogenSourceSelectedValue = $("#quick-nitrogen-source").val();	//get selected option value
		$(".all-nitrogen-sources").hide();	//hide all elements
		var nitrogenSourceSelectedValueClass = nitrogenSourceSelectedValue+"-nitrogen-source";	//set option calss name based on option with postfix as "-nitrogen-source"
		$("."+nitrogenSourceSelectedValueClass).show();	//using option class name to get related "nitrogen-source" elements
		$("label."+nitrogenSourceSelectedValueClass).css('display','inline-block');	//adding css ('display':'inline-block') to label dynamically
		
		
		/* important to show error messages on change of selectbox */
		//setting related input error messages on change of nitrogen-source selectbox - start
		inputsKeyUpEvent();
		//setting related input error messages on change of nitrogen-source selectbox - end
		
		
		//check what value is clicked, if the value is not "default-selection", then add class ".source-selected" to ".select-box-container" element to set arrow mark and font styles based on ".source-selected" class. And stop hover styles based on this class ".source-selected" - start
		if(nitrogenSourceSelectedValue != "default-selection"){
			// alert(nitrogenSourceSelectedValue);
			var dataAnalyticsValue = $('#calculate-btn').data('analytics-value'); //getter
			$('#calculate-btn').attr('analytics-value', nitrogenSourceSelectedValue); //setter
			$(".select-box-container").addClass("source-selected-active");
			$('[data-calculate-btn]').attr('disabled', false);

		}else{
			$(".select-box-container").removeClass("source-selected-active");
		}
		//check what value is clicked, if the value is not "default-selection", then add class ".source-selected" to ".select-box-container" element to set arrow mark and font styles based on ".source-selected" class. And stop hover styles based on this class ".source-selected" - end
		
	});

	$("[data-calculate-btn]").click(function() {
		$(".results, .heading").addClass("active"); //activate the active state on the results container to draw attention to it
	});
	
	//if query parameter "q" is not null, then set query parameter "q" as selected option value in the selectbox of "#quick-nitrogen-source"
	//if query_string('q') has no proper value-('anhydrous', 'uan-28', 'uan-32', 'urea'), then show default selection screen as default
	//if(getParameterByName('q') != null){}
	if(getParameterByName('q') == 'anhydrous' || getParameterByName('q') == 'uan-28' || getParameterByName('q') == 'uan-32' || getParameterByName('q') == 'urea'){
		query_string = getParameterByName('q');
		$("#quick-nitrogen-source").val(query_string);
		
		/* on load query parameter("q") at custom selectbox list - start */	//Just setting selected text to ".custom-select-list-value"
			//ON Load with query parameter("q"):
			//use query parameter("q") value text as a selector(class) of ".custom-select-list-container .custom-select-list li" as it is aleady set to list as a selector(class), 
			//and get text of that list selector(class) with postfix as "-list", 
			//and set that list text to ".custom-select-list-value"
				var query_string_selector_text = $("."+query_string+"-list").text();
				$(".custom-select-list-value").text(query_string_selector_text);
		/* on load query parameter("q") at custom selectbox list - list */	//Just setting selected text to ".custom-select-list-value"
	}else{
		//if there is no query parameter, then set values to default manually - because firefox is setting previous selected value in selectbox as selected. So setting the default-selection value to selectbox as selected value to show default loading screen.
		$("#quick-nitrogen-source").val("default-selection");	//setting default value as selectbox selected value to load default no selection screen.
	}
	$("#quick-nitrogen-source").trigger("change");	//At onload of document, tigger onchange event of "#quick-nitrogen-source" selectbox to find the selected  option and change elements related to selected option based on option value with "-nitrogen-source" as postfix
	
	
	/* .custom-select-list click event to trigger selectbox change event - start */
		$(".custom-select-list-value-container").click(function(){	//newly added 
			//show lists on click on value
			$(".custom-select-list-container .custom-select-list").toggle();
		});
		
		$(".custom-select-list-container .custom-select-list li").click(function(){

			//get "data-select-value" attribute of li
			var dataSelectValue = $(this).attr("data-select-value");
			var selectValueText = $(this).html();
			var avgYieldIncrease = $("input#quick-average-yield-increase-with-product-instinct-n-serve");
			$(".custom-select-list-container .custom-select-list").hide();
			$(".custom-select-list-value").html(selectValueText);
			//set clicked list(li) "data-select-value" attribute value to "#quick-nitrogen-source" value to make selectbox option active based on "data-select-value" attribute value
			$("#quick-nitrogen-source").val(dataSelectValue);
			//trigger selectbox change event as selectbox("#quick-nitrogen-source") is changed based on above statement.
			$("#quick-nitrogen-source").trigger("change");
			$('.value-of-yield').show(); //show the value of yield icon after one of the sources is selected
			avgYieldIncrease.attr('value', '7%');
			
			// set different new average yield input value depending on what is selected in the custom select list value container
			// if(dataSelectValue == "anhydrous") {
			// 	avgYieldIncrease.attr('value', '5.2%');
			// } else {
			// 	avgYieldIncrease.attr('value', '7%');
			// }

			//clear any errors after setting the new average yield input value
			inputsKeyUpEvent();
			
			//if the gtag function exists 
			if (typeof gtag == 'function') {
				gtag_report_conversion_nitrogen_source();
			}
			
		
		});
		$(document).click(function(e){	/* newly added */
			var clickElement = e.target;  // get the dom element clicked.
			var elementClassName = e.target.className;  // get the classname of the element clicked
			if(elementClassName !="custom-select-list-value-container" && elementClassName !="custom-select-list-value" && elementClassName !="select-box-dropdown-arrow" && elementClassName !="select-box-dropdown-arrow-img" && elementClassName !="text" && elementClassName !="select-box-dropdown-arrow-img source-dropdown-arrow-image" && elementClassName !="select-box-dropdown-arrow-img source-dropdown-arrow-image-hover" && elementClassName !="select-box-dropdown-arrow-img source-dropdown-arrow-image-selected" && elementClassName !="sub-selection" ) {
				//alert(elementClassName);
				$(".custom-select-list-container .custom-select-list").hide();
			}
		});
	/* .custom-select-list click event to trigger selectbox change event - end */
	
	/* icon description show/hide functionality - start */	/* newly added */
	$(".icon").click(function(){
		$(".icon_description").hide();		//hide all descriptions
		$(".icon").removeClass("active");	//remove active class to all icons
			
		$(this).addClass("active");
		$(this).parent().find(".icon_description").show();
	});
	$(".icon_close").click(function(){
		$(".icon_description").hide();		//hide all descriptions
		$(".icon").removeClass("active");	//remove active class to all icons
		$(this).parent().hide();
		$(this).closest(".icon_container").find(".icon").removeClass("active");
	});
	$(document).click(function(e){
		var clickElement = e.target;  // get the dom element clicked.
		var elementClassName = e.target.className;  // get the classname of the element clicked
		if(elementClassName !="icon" && elementClassName !="icon active" && elementClassName !="icon_description" && elementClassName !="icon_close" ) {
			$(".icon_description").hide();
			$(".icon").removeClass("active");
		}
	});
	/* icon description show/hide functionality - end */
});




// ===== find query parameter (to open required calculator based on query string) - start ===== //
function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* important to show error messages on change of selectbox */
//setting related input error messages on change of nitrogen-source selectbox - start
	function inputsKeyUpEvent(){
		$(".error-messages").hide();	//hide at selectbox change triggered. Then find the selected option and then show related error messages of input box by triggering keyup event to all input elements of related selected option with if else conditions, it is coded below.
		/* trigger if any selections is existed */
		if(nitrogenSourceSelectedValue != "default-selection"){
			if(nitrogenSourceSelectedValue == "anhydrous"){
				//N Serve
				$("#quick-cost-of-product-n-serve-per-acre").trigger("keyup");
				$("#quick-corn-yield-bushels-acre").trigger("keyup");
				$("#quick-average-yield-increase-with-product-instinct-n-serve").trigger("keyup");
				$("#quick-corn-price-per-bushel").trigger("keyup");
				$("#quick-total-acres").trigger("keyup");
			}else{
				//Instinct II
				$("#quick-cost-of-product-instinct-per-acre").trigger("keyup");
				$("#quick-corn-yield-bushels-acre").trigger("keyup");
				$("#quick-average-yield-increase-with-product-instinct-n-serve").trigger("keyup");
				$("#quick-corn-price-per-bushel").trigger("keyup");
				$("#quick-total-acres").trigger("keyup");
			}
		}
	}
//setting related input error messages on change of nitrogen-source selectbox - end

$(window).on('load', function(){
	/* important to show error messages on change of selectbox */
	//setting related input error messages on change of nitrogen-source selectbox - start
	setTimeout(function(){
		inputsKeyUpEvent();
	}, 300);
	//setting related input error messages on change of nitrogen-source selectbox - end
});

//removing crtl-z functionality for input fields - start
$(".calculation-fields input").keydown(function(e){
  var zKey = 90;
  if ((e.ctrlKey || e.metaKey) && e.keyCode == zKey) {
    e.preventDefault();
    return false;
  }
});
//removing crtl-z functionality for input fields - end

